import React, { useState } from 'react';
import { EmailProvider } from '../context/EmailContext';
import DraftComposer from '../components/email/DraftComposer';
import DraftHistory from '../components/email/DraftHistory';
import EmailSettings from '../components/email/EmailSettings';
import AutopilotSettings from '../components/email/AutopilotSettings'; // New Import
import SafeIcon from '../common/SafeIcon';

const ContentProxy = () => {
  const [activeTab, setActiveTab] = useState('composer');

  return (
    <div className="p-8 max-w-[1600px] mx-auto min-h-screen space-y-8">
      {/* Header */}
      <div className="flex justify-between items-center border-b border-slate-200 pb-6">
        <div>
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-purple-50 text-purple-700 rounded-full text-[10px] font-black uppercase tracking-widest mb-2 border border-purple-100">
            <SafeIcon icon="🤖" className="w-3 h-3" /> AI Copilot
          </div>
          <h1 className="text-3xl font-black text-slate-900 tracking-tight">Email Copilot</h1>
          <p className="text-slate-500 font-medium mt-1">La AI skrive utkastene. Du beholder kontrollen.</p>
        </div>
      </div>

      {/* Tabs */}
      <div className="flex gap-1 bg-slate-100/50 p-1 rounded-xl w-fit">
        {[
          { id: 'composer', label: 'Ny E-post', icon: '✍️' },
          { id: 'history', label: 'Historikk', icon: '📂' },
          { id: 'settings', label: 'Innstillinger', icon: '⚙️' },
          { id: 'autopilot', label: 'Autopilot', icon: '🚀' } // New Tab
        ].map(tab => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`px-6 py-2.5 rounded-lg text-xs font-black uppercase tracking-widest transition-all flex items-center gap-2 ${activeTab === tab.id ? 'bg-white text-slate-900 shadow-sm' : 'text-slate-500 hover:text-slate-700'}`}
          >
            <SafeIcon icon={tab.icon} /> {tab.label}
          </button>
        ))}
      </div>

      {/* Content */}
      <div className="animate-in fade-in slide-in-from-bottom-4 duration-500 min-h-[600px]">
        {activeTab === 'composer' && <DraftComposer />}
        {activeTab === 'history' && <DraftHistory />}
        {activeTab === 'settings' && <EmailSettings />}
        {activeTab === 'autopilot' && <AutopilotSettings />}
      </div>
    </div>
  );
};

const EmailCopilot = () => (
  <EmailProvider>
    <ContentProxy />
  </EmailProvider>
);

export default EmailCopilot;